export var FloorSize;
(function (FloorSize) {
    FloorSize["SMALL"] = "small";
    FloorSize["LARGE"] = "large";
})(FloorSize || (FloorSize = {}));
export var FloorSizeValues = [FloorSize.SMALL, FloorSize.LARGE];
export var isSpaceTag = function (x) {
    return !!x.title;
};
export var isTableTag = function (x) {
    return !!x.space;
};
export function isAssignedOwner(o) {
    /*
      Accessing o.table and o.stickersNumber is a hack, so that MobX observers
      react to changes in those as well. Normally @computed values are re-calculated
      only when data used in the calculations changes. In out case we compute
      the output array based on just o.floor and o.space, but in our views we
      are interested in o.table and o.stickersNumber as well.
  
      @todo: If you know a cleaner way on how to fix this, feel free to do so.
    */
    var floor = o.floor;
    var space = o.space;
    var table = o.table;
    var sn = o.stickersNumber;
    return floor !== null && space !== null && (table !== null || table === null) && (sn !== null || sn === null);
}
export function isAssignedTo(o, s) {
    /*
      Accessing o.table and o.stickersNumber is a hack, so that MobX observers
      react to changes in those as well. Normally @computed values are re-calculated
      only when data used in the calculations changes. In out case we compute
      the output array based on just o.floor and o.space, but in our views we
      are interested in o.table and o.stickersNumber as well.
  
      @todo: If you know a cleaner way on how to fix this, feel free to do so.
    */
    var floor = o.floor;
    var space = o.space;
    var table = o.table;
    var sn = o.stickersNumber;
    return (floor !== null &&
        space !== null &&
        space.id === s.id &&
        (table !== null || table === null) &&
        (sn !== null || sn === null));
}
export var FloorPlanEditState;
(function (FloorPlanEditState) {
    FloorPlanEditState["Upload"] = "floor plan";
    FloorPlanEditState["Mark"] = "areas";
    FloorPlanEditState["Connect"] = "people";
    FloorPlanEditState["Finish"] = "labels";
})(FloorPlanEditState || (FloorPlanEditState = {}));
export var MarkingType;
(function (MarkingType) {
    MarkingType["Space"] = "space";
    MarkingType["Table"] = "table";
})(MarkingType || (MarkingType = {}));
export var UserType;
(function (UserType) {
    UserType["RPM"] = "relokatorPM";
    UserType["CPM"] = "clientPM";
    UserType["END"] = "endUser";
})(UserType || (UserType = {}));
//# sourceMappingURL=floorplan.js.map